import { render } from "./ViewTitle.vue?vue&type=template&id=db3047b0&scoped=true&ts=true"
import script from "./ViewTitle.vue?vue&type=script&lang=ts"
export * from "./ViewTitle.vue?vue&type=script&lang=ts"

import "./ViewTitle.vue?vue&type=style&index=0&id=db3047b0&scoped=true&lang=less"
import "./ViewTitle.vue?vue&type=style&index=1&id=db3047b0&lang=less"

import exportComponent from "D:\\Code\\BranchManageSystem\\UI\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db3047b0"]])

export default __exports__